import { Component } from '@angular/core';

@Component({
  selector: 'app-administrator-profile',
  templateUrl: './administrator-profile.component.html',
  styleUrls: ['./administrator-profile.component.scss'],
})
export class AdministratorProfileComponent {}
